<ng-container *ngIf="!!contextualHelp && contextualHelp?.length">
  <div class="jb-contextual-help jb-grid gr-unset justify-center">
    <jb-contextual-help class="col-8-m-temp">
      <jb-contextual-help-header>{{
        contextualHelp[0]?.title
      }}</jb-contextual-help-header>
      <jb-contextual-help-content *ngIf="!!contextualHelp[0]?.copy">
        {{ contextualHelp[0]?.copy }}
      </jb-contextual-help-content>
      <a
        *ngIf="!!contextualHelp[0]?.link"
        [jbSitemapLinker]="(contextualHelp[0]?.link)[0]?.href"
        [target]="(contextualHelp[0]?.link)[0]?.newWindow"
        [dotLinkIcon]="(contextualHelp[0]?.link)[0]?.newWindow"
        jbActionLink
        >{{ (contextualHelp[0]?.link)[0]?.title }}</a
      >
    </jb-contextual-help>
  </div>
</ng-container>
